export default "__VITE_ASSET__ByFwvNYn__"